export default "__VITE_ASSET__0dacb55f__"